import _ from 'lodash';

const VIPValidator = (props) => {
  const existingCodes = [];

  _.map(props.vip_codes, ({ codes, group_id }) => {
    if (group_id === _.get(props.selectedRow, 'group_id', '-1')) {
      return; // check for edit and drop exist codes for validation
    }

    _.map(codes, (code) => (existingCodes.push(code)));
  });

  const codeValidation = !!_.size(props.codes);
  const appliedToTickets = props.applied_to_all_tickets ? true : !!_.size(props._applied_to_tickets);
  const codes = _.intersection(existingCodes, props.codes);
  const codeExist = !codes.length > 0;

  const requiredFields = [
    { value: appliedToTickets, key: 'appliedToTickets' },
    { value: codeValidation, key: 'codeValidation' },
    { value: codeExist, key: 'codeExist', codes }
  ];

  return _.compact(_.map(requiredFields, (rf) => {
    if (!rf.value) return rf;

    return null;
  }));
};

export default VIPValidator;

